import { Box, Grid } from '@mui/material';
import * as React from 'react';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';

export function MediaDetailsFields(props) {

	const [mediaTypeOptions, setMediaTypeOptions] = React.useState([]);
	const [mediaTypeBandMap, setMediaTypeBandMap] = React.useState({});
	const [filteredBandOptions, setFilteredBandOptions] = React.useState([]);


	React.useEffect(() => {
		if (!props.companyCode || props.modelDefId !== 3) return;

		httpGet(`/api/invoicedocument/mediatypebands/${props.companyCode}`)
			.then((response) => {
				const data = response.data;
				const mediaMap = {};
				const mediaList = [];

				data.forEach(item => {
					if (!mediaMap[item.mediaTypeCode]) {
						mediaMap[item.mediaTypeCode] = [];
						mediaList.push({
							value: item.mediaTypeCode,
							label: item.mediaTypeName
						});
					}
					mediaMap[item.mediaTypeCode].push(item.mediaTypeBand);
				});

				setMediaTypeOptions(mediaList);
				setMediaTypeBandMap(mediaMap);

				const selectedMediaType = props.mappedFields['mediaType']?.value;
				const allBands = Array.from(new Set(data.map(item => item.mediaTypeBand)));
				const bandDropdown = (bands) => [{ value: '', label: 'Select Band' }, ...bands.map(b => ({ value: b, label: b }))];

				if (selectedMediaType && mediaMap[selectedMediaType]) {
					setFilteredBandOptions(bandDropdown(mediaMap[selectedMediaType]));
				} else {
					setFilteredBandOptions(bandDropdown(allBands));
				}

			})
			.catch(() => toast.error("Failed to load media type and band options"));
	}, [props.companyCode]);


	const handleChange = (field) => (event) => {
		const value = event.target.value;

		if (field === 'mediaType') {
			const allBands = Array.from(new Set(Object.values(mediaTypeBandMap).flat()));
			const bands = value ? mediaTypeBandMap[value] || [] : allBands;
			setFilteredBandOptions([{ value: '', label: 'Select Band' }, ...bands.map(b => ({ value: b, label: b }))]);

			props.field_changehandler({
				event: { target: { value: '' } },
				value: 'band'
			});
		}

		props.field_changehandler({
			event: { target: { value: value } },
			value: field
		});
	};



	return (
		<div className="mf-12">
			<Box>
				{props.modelDefId === 3 && (
					<>
						<Grid container
							spacing={props.style.mainRowSpacing}
							sx={props.style.mainRowStyle}>
							<Grid item xs={props.style.cellOneWidth}
								sx={props.style.cellOneStyle}>
								<label>Media Type</label>
							</Grid>
							<Grid item
								xs={props.style.cellTwoWidth}
								sx={props.style.cellTwoStyle}>
								<select
									value={props.mappedFields['mediaType']?.value || ''}
									onChange={handleChange('mediaType')}
									disabled={props.readOnly}
									style={{ width: '100%', ...props.style.inputStyle }}
								>
									<option value="">Select Media Type</option>
									{mediaTypeOptions.map((opt) => (
										<option key={opt.value} value={opt.value}>{opt.label}</option>
									))}
								</select>
							</Grid>
						</Grid>

						<Grid container
							spacing={props.style.mainRowSpacing}
							sx={props.style.mainRowStyle}>
							<Grid item xs={props.style.cellOneWidth}
								sx={props.style.cellOneStyle}>
								<label>Band</label>
							</Grid>
							<Grid item
								xs={props.style.cellThreeWidth}
								sx={props.style.cellThreeStyle}>
								<select
									value={props.mappedFields['band']?.value || ''}
									onChange={handleChange('band')}
									disabled={props.readOnly}
									style={{ width: '100%', ...props.style.inputStyle }}
								>
									{filteredBandOptions.map((opt) => (
										<option key={opt.value} value={opt.value}>{opt.label}</option>
									))}
								</select>

							</Grid>
						</Grid>

						<Grid container
							spacing={props.style.mainRowSpacing}
							sx={props.style.mainRowStyle}>
							<Grid item
								xs={props.style.cellOneWidth}
								sx={props.style.cellOneStyle}>
								<label>Call Letter</label>
							</Grid>
							<Grid item
								xs={props.style.cellThreeWidth}
								sx={props.style.cellThreeStyle}>
								<input
									type="text"
									value={props.mappedFields['callLetter']?.value || ''}
									onChange={handleChange('callLetter')}
									maxLength={4}
									disabled={props.readOnly}
									style={{ width: '100%', ...props.style.inputStyle }}
								/>
							</Grid>
						</Grid>

						
					</>
				)}
			</Box>
		</div>
	);
}
